module.exports = __webpack_public_path__ + "img/prion-banner2.bcc45be0.png";